import React from 'react';
import PropTypes from 'prop-types';
import css from './BatchSentItemsApp.scss';
import BatchSendItemsHeader from './BatchSentItemsHeader';
import BatchSendItemStats from './BatchSentItemStats';
import { fetchAuthenticatedStarfishJSON } from '../utils/request';
import reportError from 'utils/report-error';
import { hot } from 'react-hot-loader';
import BatchSentItemsTable from './BatchSentItemsTable';

class BatchSentItemsApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      batchedActions: [],
      loading: false
    };
    this.batchSentItemsRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ loading: true });
    fetchAuthenticatedStarfishJSON(
      '../instructor/getMyBatchActions.html',
      'batchedActions',
      {
        method: 'GET'
      })
      .then(batchedActions => this.setState({ batchedActions }))
      .catch(reportError)
      .then(() => this.setState({ loading: false }, this.focusBatchSentItems ));
  }

  focusBatchSentItems() {
    if (location.hash === "#batchSentItems" )
      this.batchSentItemsRef.current && this.batchSentItemsRef.current.focus()
  }

  renderSortableTable = () => <BatchSentItemsTable items={this.state.batchedActions} 
                                                   loading={this.state.loading} 
                                                   loadingContent="Loading batch sent items..." />;

  render() { 
    return ( 
      <div className={css['batch-send-item']} id="batchSentItems" tabIndex={0} ref = {this.batchSentItemsRef}>
        <BatchSendItemsHeader />
        <div className={css['overflow-y-scroll']}>
          {this.renderSortableTable()}
        </div>
        <BatchSendItemStats
          numberOfItems={this.state.batchedActions.length}
          timeRange={this.props.timeRange} />
      </div>
    );
  }
}

BatchSentItemsApp.propTypes = {
  timeRange: PropTypes.number.isRequired
};

export default hot(module)(BatchSentItemsApp);
